"use client";

import { useEffect, useRef } from "react";
import { useDebounce } from "@/hooks/use-debounce";
import { trackToolUsed } from "@/lib/analytics/tool-events";
import type { PublicTool } from "@shared/analytics/tools";

export const TOOL_COMPUTED_SETTLE_MS = 1500;

export function useToolComputed(
  tool: PublicTool,
  computationKey: string | null,
  productTypeSlug?: string,
): void {
  const settledKey = useDebounce(computationKey, TOOL_COMPUTED_SETTLE_MS);
  const lastRecordedKey = useRef(computationKey);

  useEffect(() => {
    if (settledKey === null || settledKey === lastRecordedKey.current) return;
    lastRecordedKey.current = settledKey;
    trackToolUsed({ tool, tool_step: "computed", productTypeSlug });
  }, [settledKey, tool, productTypeSlug]);
}
